const recent = new Map<string, { key: string; at: number }>();
const WINDOW_MS = 20000;

const newKey = (): string =>
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? (crypto as any).randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;

export function orderIdempotencyKey(payload: unknown): string {
    const signature = JSON.stringify(payload);
    const now = Date.now();
    recent.forEach((value, id) => { if (now - value.at > WINDOW_MS) recent.delete(id); });
    const hit = recent.get(signature);
    if (hit) return hit.key;
    const key = newKey();
    recent.set(signature, { key, at: now });
    return key;
}

export function withIdempotencyKey<T extends object>(payload: T): T & { idempotencyKey: string } {
    const { idempotencyKey, ...rest } = payload as any;
    return { ...(payload as any), idempotencyKey: idempotencyKey ?? orderIdempotencyKey(rest) };
}
